var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('App',{attrs:{"keepAliveInclude":_vm.keepAliveInclude}})}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }